document.addEventListener('DOMContentLoaded', () => {
	const sidebarAnchors = document.querySelector('.sidebar-anchors');
	const textDiv = document.querySelector('.text');

	if (sidebarAnchors && textDiv) {
		const headings = textDiv.querySelectorAll('h2, h3');
		const anchorMap = new Map();

		headings.forEach((heading, index) => {
			// Generate a unique ID for each heading if it doesn't have one
			if (!heading.id) {
				heading.id = `heading-${index}`;
			}

			const listItem = document.createElement('li');
			const anchor = document.createElement('a');
			const icon = document.createElement('i');

			icon.className =
				'fa-regular fa-arrow-right opacity-0 transition-all text-primary absolute -left-6 top-[21px] group-hover/listitem:left-6 group-hover/listitem:opacity-100 [.active_&]:opacity-100 [.active_&]:left-6';
			listItem.className = 'list-none border-t border-tertiary group/listitem';
			anchor.className =
				'no-underline overflow-hidden leading-relaxed font-medium text-base transition-all px-6 py-4 relative block group-hover/listitem:pl-12 [&.active]:pl-12 [&.active]:bg-tertiary-50 group-hover/listitem:bg-tertiary-50 group-hover/listitem:text-primary [&.active]:text-primary';

			// Set anchor href to the heading's ID and text content
			anchor.href = `#${heading.id}`;
			anchor.textContent = heading.textContent;

			listItem.appendChild(anchor);
			anchor.appendChild(icon);
			sidebarAnchors.appendChild(listItem);

			// Map the heading ID to the anchor element
			anchorMap.set(heading.id, anchor);

			anchor.addEventListener('click', (event) => {
				event.preventDefault();

				// Get the heading's position relative to the page
				const targetPosition = heading.getBoundingClientRect().top + window.scrollY;
				const offset = 200;

				window.scrollTo({
					top: targetPosition - offset,
					behavior: 'smooth',
				});
			});
		});

		// Handle active class on scrolling
		const observerOptions = {
			root: null,
			rootMargin: `10% 0px -80% 0px`, // Tweak this to leave the active class longer on the anchor
			threshold: 0.5,
		};

		const observerCallback = (entries) => {
			entries.forEach((entry) => {
				const anchor = anchorMap.get(entry.target.id);
				if (entry.isIntersecting) {
					anchor.classList.add('active');
				} else {
					anchor.classList.remove('active');
				}
			});
		};

		const observer = new IntersectionObserver(observerCallback, observerOptions);
		headings.forEach((heading) => observer.observe(heading));
	}
});

document.addEventListener('DOMContentLoaded', function () {
	const sidebar = document.querySelector('.sidebar');
	const anchorsList = document.querySelector('.sidebar-anchors');

	if (sidebar && anchorsList && anchorsList.children.length === 0) {
		sidebar.remove();
	}
});
